import { useAuth } from '@services/auth'
import {
  INotification,
  useChargeEventNotification,
} from '@services/notification'
import moment from 'moment'
import React, { useEffect } from 'react'

const StorageKey = 'ChargeNotificationIds'

function getShowedIds(): number[] {
  const stored = localStorage.getItem(StorageKey)
  if (stored) {
    try {
      const parsed = JSON.parse(stored)
      return parsed
    } catch {
      // Ignore JSON parse errors
    }
  }
  return []
}

function setShowedId(id: number) {
  const currentIds = getShowedIds()
  try {
    // Test if localStorage write was successful
    localStorage.setItem(StorageKey + '_test', 'test')
    localStorage.removeItem(StorageKey + '_test')
    localStorage.setItem(StorageKey, JSON.stringify([...currentIds, id]))
  } catch (error) {
    if (error instanceof DOMException && error.name === 'QuotaExceededError') {
      // Remove first third of stored IDs to free up space
      const keepCount = Math.floor((currentIds.length * 2) / 3)
      const idsToKeep = currentIds.slice(-keepCount)
      localStorage.setItem(StorageKey, JSON.stringify([...idsToKeep, id]))
    }
  }
}

const useChargeNotification = () => {
  const { isAuthenticated } = useAuth()

  const isAuthenticatedRef = React.useRef(isAuthenticated)

  const [timeAfter, setCurrentTimeAfter] = React.useState(moment().valueOf())

  const { dataSource } = useChargeEventNotification(
    {
      timeAfter,
      pageNum: 0,
      pageSize: 50,
    },
    {
      enabled: isAuthenticated,
      displayError: false,
    }
  )

  useEffect(() => {
    isAuthenticatedRef.current = isAuthenticated
  }, [isAuthenticated])

  useEffect(() => {
    if (!isAuthenticatedRef.current) {
      return
    }
    const interval = setInterval(() => {
      setCurrentTimeAfter(moment().valueOf())
    }, 60000) // 每分鐘更新

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (!isAuthenticatedRef.current) {
      return
    }
    const emitNotification = (item: INotification) => {
      new Notification(item.eventStr, {
        body: item.content,
        icon: '/favicon.ico',
      })
    }

    dataSource?.content?.forEach(item => {
      const showedIds = getShowedIds()
      if (showedIds.includes(item.id)) {
        return
      }
      if ('Notification' in window) {
        if (Notification.permission === 'granted') {
          emitNotification(item)
        } else if (Notification.permission !== 'denied') {
          Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
              emitNotification(item)
            }
          })
        }
        setShowedId(item.id)
      } else {
        console.log('This browser does not support notifications')
      }
    })
  }, [dataSource])
}

export default useChargeNotification
